import {getMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/ownProductExtraServices', request)
}

async function post(request) {
    return await postMethod('/api/ownProductExtraServices', request)
}

async function put(request) {
    return await putMethod('/api/ownProductExtraServices', request)
}

export {get, post, put}
